import { executeApi } from "./apiHelper";

// Server request audit owns business evidence. Downloads remain explicitly client-reported.
export const logReportDownload = async ({ path = window.location.pathname } = {}) =>
  executeApi("logs-recordClientEvent", { eventType: "download_report", page: path.split("?")[0] });
